import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/QuickPay/";
    return {
        IsNicorCustomer(request) {
            var url = baseUrl + "IsNicorCustomer";
            return Proxy.Post(url, request);
        },
        GetAmountToAvoidDisconnect(request) {
            var url = baseUrl + "GetAmountToAvoidDisconnect";
            return Proxy.Post(url, request);
        },
        ValidateAccountNumber(request) {
            var url = baseUrl + "ValidateAccountNumber";
            return Proxy.Post(url, request);
        },
        GetStatusCode(request) {
            var url = baseUrl + "GetStatusCode";
            return Proxy.Post(url, request);
        },
        GetBillingTypeCode(request) {
            var url = baseUrl + "GetBillingTypeCode";
            return Proxy.Post(url, request);
        },
        GetCustomerTypeCode(request) {
            var url = baseUrl + "GetCustomerTypeCode";
            return Proxy.Post(url, request);
        },
        GetAllBalancesByCustomerNumber(request) {
            var url = baseUrl + "GetAllBalancesByCustomerNumber";
            return Proxy.Post(url, request);
        },
        GetCustomerBalance(request) {
            var url = baseUrl + "GetCustomerBalance";
            return Proxy.Post(url, request);
        },
        GetAmountToReinstateByCustomerNbr(request) {
            var url = baseUrl + "GetAmountToReinstateByCustomerNbr";
            return Proxy.Post(url, request);
        },
        ValidatePhoneNumber(request) {
            var url = baseUrl + "ValidatePhoneNumber";
            return Proxy.Post(url, request);
        },
        IsCCFeeCharged(request) {
            var url = baseUrl + "IsCCFeeCharged";
            return Proxy.Post(url, request);
        },
        IsAgentFeeCharged(request) {
            var url = baseUrl + "IsAgentFeeCharged";
            return Proxy.Post(url, request);
        },
        GetCustomerName(request) {
            var url = baseUrl + "GetCustomerName";
            return Proxy.Post(url, request);
        },
        GetCustomerProviderAndState(request) {
            var url = baseUrl + "GetCustomerProviderAndState";
            return Proxy.Post(url, request);
        },
        GetAppSetting(request) {
            var url = baseUrl + "GetApplicationSetting";
            return Proxy.Post(url, request);
        },
    };
})()